import { EmployeeWorkgroup } from '../employee-workgroup';
import {
  IEmployeeWorkgroup,
  IEmployeeWorkgroupData
} from '../employee-workgroup.types';

export const mockEmployeeWorkgroupsData = (): IEmployeeWorkgroupData[] => [
  {
    id: 1,
    name: 'Technical Associate I',
    description: 'IT'
  },
  {
    id: 2,
    name: 'Technical Associate II',
    description: 'Engineering'
  }
];

export const mockEmployeeWorkgroups = (
  data: IEmployeeWorkgroupData[] = mockEmployeeWorkgroupsData()
): IEmployeeWorkgroup[] => data.map(item => new EmployeeWorkgroup(item));
